import React from 'react'
import Shirt from '../components/Shirt'
import './KabaddiTeamScores.scss'
import { FaRegClock } from 'react-icons/fa'

export default function KabaddiTeamScores ({ teams, scoreboard, showClock = false }) {
    function getValueFromScoreboard(name) {
        if (!scoreboard) {
            return null
        }

        const found = scoreboard.find(i => i.name === name)

        if (found){
            return found.value
        }

        return null
    }
    
    const clock = Number(getValueFromScoreboard('Clock'))

    const teamOneName = getValueFromScoreboard('TeamA')
    const teamTwoName = getValueFromScoreboard('TeamB')

    const teamOnePlayers = Number(getValueFromScoreboard('TeamA Players'))
    const teamTwoPlayers = Number(getValueFromScoreboard('TeamB Players'))

    const teamOneScore = getValueFromScoreboard('TeamA Points')
    const teamTwoScore = getValueFromScoreboard('TeamB Points')

    let halfText = Number(getValueFromScoreboard('Raid.B')) < 41 ? 'First half' : 'Second half'

    const status = getValueFromScoreboard('Status')
    if (status === 'Match Complete' || status === 'Event Closed') {
        halfText = 'Match Complete'
    }
    
    return (
        <div className="kabaddi-team-scores">
            <div className="kabaddi-teams">
                <div className="kabaddi-team">
                    <div className="kabaddi-team-name-and-players">
                        <div className="kabaddi-team-name">{teamOneName}</div>
                        <div className="kabaddi-team-players">
                            {
                                [...Array(teamOnePlayers)].map((_, i) => (
                                    <Shirt 
                                        key={i} 
                                        primaryColour={teams[0].colour} 
                                        secondaryColour={teams[0].team_colour}
                                        size={15}
                                    />
                                ))
                            }
                        </div>
                    </div>
                    
                    <div className="kabaddi-team-score-and-overs">
                        <div className="kabaddi-team-score">{teamOneScore}</div>
                        <div className="kabaddi-team-overs">({teamOnePlayers})</div>
                    </div>
                </div>
                <div className="kabaddi-team">
                    <div className="kabaddi-team-name-and-players">
                            <div className="kabaddi-team-name">{teamTwoName}</div>
                            <div className="kabaddi-team-players">
                                {
                                    [...Array(teamTwoPlayers)].map((_, i) => (
                                        <Shirt 
                                            key={i} 
                                            primaryColour={teams[1].colour} 
                                            secondaryColour={teams[1].team_colour}
                                            size={15}
                                        />
                                    ))
                                }
                            </div>
                    </div>
                    <div className="kabaddi-team-score-and-overs">
                        <div className="kabaddi-team-score">{teamTwoScore}</div>
                        <div className="kabaddi-team-overs">({teamTwoPlayers})</div>
                    </div>
                </div>
            </div>
            { showClock && 
                <div className="clock">
                    <FaRegClock size={25}/> 
                    <div>{clock} mins</div>
                    <div style={{ marginTop: 5 }}>{halfText}</div>
                </div>
            }
        </div>
    )
}